import React from 'react';
import {
  Typography,
  Button,
  Dialog,
  Grid,
  Card,
  CardMedia,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MarkdownIt from 'markdown-it';
import { discount_unit } from '../../utils';
import logo from '../../components/Logo/logo-dermpro.svg';


const md = new MarkdownIt();

const useStyles = makeStyles(() => ({
  modal: {
    minWidth: '768px',
    maxWidth: '768px'
  },
  imageblock: {
    height: '240px',
  },
  cardImage: {
    objectFit: 'scale-down',
  },
  cardBackground: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    height: '240px',
  },
  description: {
    maxHeight: '60px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  content: {
    position: 'relative',
    margin: '20px 0'
  },
  button: {
    margin: '20px 10px 10px 10px'
  },
}));

const PromoDetailsModal = ({ selectedPromo, setSelectedPromo }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={selectedPromo?._id}
      onClose={() => setSelectedPromo({})}
      maxWidth="md"
    >
      <div className={classes.modal}>
        <Card elevation="25" className="p-5" spacing={4}>
          <Grid container>
            <Grid item md={12} sm={6} xs={12} className={classes.imageBlock}>
              {selectedPromo.slider?.bannerImageInfo ?
                <CardMedia
                  component="img"
                  className={classes.cardImage}
                  height="140"
                  alt="Image not found"
                  image={selectedPromo.slider?.bannerImageInfo?.imageS3}
                  title={selectedPromo.promoName}
                /> :
                <CardMedia image={logo} className={classes.cardImage} title={selectedPromo.promoName}>
                  <div elevation={25} className={classes.cardBackground} />
                </CardMedia>
              }
            </Grid>
            <Grid item md={12} sm={6} xs={12} className={classes.content}>
              <Typography gutterBottom variant="h5" component="h2" className="mb-2">
                {selectedPromo.promoName}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                <span className="font-semibold">Discount Type: </span>
                {selectedPromo.promoType?.typeName}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p" className={classes.description} title={selectedPromo.promoDescription}>
                <span className="font-semibold">Description: </span>
              </Typography>
              <div dangerouslySetInnerHTML={{ __html: md.render(selectedPromo?.promoDescription || '') }} />
              {selectedPromo.salesRules?.[0] &&
                <Typography variant="body2" color="textSecondary" component="p">
                  <span className="font-semibold">Discount: </span>
                  {selectedPromo.salesRules?.[0]?.discountAmount} {discount_unit[selectedPromo.salesRules[0]?.discountType]}
                </Typography>
              }
              <Typography color="textSecondary" component="p">
                <span className="font-semibold">Promoted Listings: </span>
              </Typography>
              {selectedPromo.skusCategories?.length ?
                selectedPromo.skusCategories?.map((category) => {
                  return (
                    <Typography key={category.id} color="textSecondary" component="p">
                      {category.name}
                    </Typography>
                  );
                })
                :
                selectedPromo.skus?.map((product) => {
                  return (
                    <Typography key={product.sku} color="textSecondary" component="p">
                      {product.name}
                    </Typography>
                  );
                })
              }
            </Grid>

          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              className={classes.button}
              onClick={() => setSelectedPromo({})}
            >
              Close
            </Button>
          </Grid>
        </Card>
      </div>
    </Dialog>
  );
};

export default PromoDetailsModal;
